module.exports = __webpack_public_path__ + "media/images/pending_acceptance_icon-be71be3edc20bca1992d5d487b91400c.webp";